import React from "react";

import type { SideNavigationLink } from "../../../../../components/SideNavigation";
import ReviewCycles from "./ReviewCycles";
import ReviewCyclesRefresh from "./ReviewCyclesRefresh";

import { useFeatureFlagQuery } from "../../../../../hooks/useFeatureFlag";

type Props = {
	navLinks: SideNavigationLink[];
};

const ReviewCyclesPage = ({ navLinks }: Props) => {
	const { value: hasReviewCycleRefresh } = useFeatureFlagQuery<boolean>("ff-temp-has-review-cycle-refresh", false);

	if (hasReviewCycleRefresh) {
		return <ReviewCyclesRefresh navLinks={navLinks} />;
	}

	return <ReviewCycles navLinks={navLinks} />;
};

export default ReviewCyclesPage;
